import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme, Typo, Flex, SimpleButton } from '../../ui';

const Wrapper = styled.div`
  width: 100%;
  padding: 16px 18px;
  border: 1px solid ${theme.palette.ora200};
  border-radius: 16px;
  background: ${theme.palette.ora50};
  box-sizing: border-box;
`;

const TestEnvironmentWarning = () => {
  const { t } = useTranslation();
  const isTestEnvironment = process.env.REACT_APP_STAGE !== 'prod';

  if (!isTestEnvironment) return null;

  return (
    <Wrapper>
      <Flex direction='column' gap={12} align='stretch'>
        <Flex direction='column' gap={4}>
          <Typo.TextTitle>{t('auth.testEnvironmentTitle')}</Typo.TextTitle>
          <Typo.MediumText>{t('auth.testEnvironmentDescription')}</Typo.MediumText>
          <Typo.MediumText>{t('auth.testEnvironmentLinkLabel')}</Typo.MediumText>
        </Flex>
        <Flex justify='center'>
          <SimpleButton variant='themed' size='small' href='https://app.coursio.com/login' newTab endIcon='ExternalLink'>
            {t('auth.testEnvironmentCta')}
          </SimpleButton>
        </Flex>
      </Flex>
    </Wrapper>
  );
};

export default TestEnvironmentWarning;
